import React from 'react';
import upperFirst from 'lodash/upperFirst';

import withIntl from '../../../shared/intl-hoc';

import MoneyAmountWithCurrency from '../../../shared/money/money-amount-with-currency';

import { enum as currencies } from '../../../../../../enums/currencies';

function CurrencyConversionRow({ intl, conversion, availableCurrencies, isHiddenRub }) {
	const conversionTypeName = conversion.type === 'creation' ? 'payout creation' : 'Отмена выплаты';
	return (
		<tr>
			<td className='history-datetime'>
				{conversion.date.format('HH:mm DD.MM.YYYY')}
			</td>
			{availableCurrencies.filter(ac => ac !== 'rub' || !isHiddenRub).map((ac, index) =>
				<td className='history-amount' key={index}>
					<MoneyAmountWithCurrency
						showSign={true}
						amount={conversion[`balance_${ac}`]}
						keepDecimals={true}
						currency={currencies[ac]}
					/>
				</td>
			)}
			<td>
				<div>{upperFirst(intl(conversionTypeName))}: {conversion.payout_id}</div>
				<div>{intl('Конвертация по курсу')}: {conversion.rate || '-'}</div>
			</td>
		</tr>
	);
}

export default withIntl(CurrencyConversionRow);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/currency-conversion-table/row.js